/**
 * Promotions shown on /specials.
 *
 * Only add an entry once the offer has been confirmed by the showroom.
 * An entry appears on the page only when `enabled` is true and today's date
 * falls between `startDate` and `endDate` (inclusive, YYYY-MM-DD).
 * Regular in-stock inventory belongs on the Available Spas page, not here.
 */
export type SpecialCategory = 'Hot Tubs' | 'Outdoor Furniture' | 'Big Green Egg' | 'Spa Care'

export type Special = {
  id: string
  title: string
  offer: string
  category: SpecialCategory
  image: string
  imageAlt: string
  startDate?: string
  endDate?: string
  terms?: string
  link: { label: string; href: string }
  enabled: boolean
}

/** Carried over from the currently published patio closeout page, checked 2026-10-17. Dated expired Sundance/BGE campaigns are intentionally excluded. */
export const specials: Special[] = [
  {
    id: 'patio-closeout',
    title: 'Up to 75% Off Select In-Stock Patio Furniture',
    offer: 'Shop floor models, overstock and discontinued patio furniture while selection lasts.',
    category: 'Outdoor Furniture',
    image: 'https://drwzpk38qkpfb.cloudfront.net/www.pegasus-spas.com/uploaded/images/Specials/Polywood/In-Stock%20Patio%20Furniture%20Closeout%203.png?opt=5',
    imageAlt: 'Pegasus in-stock patio furniture closeout offer flyer',
    terms: 'Select in-stock items only. Some pieces may have minor cosmetic imperfections. All sales are final.',
    link: { label: 'See the furniture closeout details', href: 'https://www.pegasus-spas.com/SpecialsPatio.html' },
    enabled: true,
  },
]

function toDay(value: string) {
  const [year, month, day] = value.split('-').map(Number)
  return new Date(year, month - 1, day)
}

/** Enabled offers whose date window includes the given day. */
export function getActiveSpecials(today: Date = new Date()): Special[] {
  const now = new Date(today.getFullYear(), today.getMonth(), today.getDate())
  return specials.filter(
    (special) =>
      special.enabled && (!special.startDate || toDay(special.startDate) <= now) && (!special.endDate || now <= toDay(special.endDate)),
  )
}

